import * as React from "react";
import FacetHeader from "../../../FacetHeader/Algolia/components/FacetContainer/FacetHeader/FacetHeader.js";
/* empty css                    */
const FacetContainer = ({
  title,
  SearchButton,
  ClearButton,
  children
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "facet-container" }, /* @__PURE__ */ React.createElement(FacetHeader, { title, SearchButton, ClearButton }), /* @__PURE__ */ React.createElement("div", { className: "facet-container__inner" }, children));
};
export {
  FacetContainer as default
};
//# sourceMappingURL=FacetContainer.js.map
